export const Questions = [
  {
    section: 'Принципи МГП. Джерела МГП',
    questions: [
      {
        prompt: 'Що відноситься до основних принципів МГП?',
        option_a:
          'Законність, обмеження, розрізнення, пропорційність, гуманність та військова необхідність',
        option_b:
          'Законність, обмеження, розрізнення, доцільність, людяність та військова необхідність',
        option_c:
          'Законність, вибірковість, розрізнення, доцільність, гуманність та військова необхідність',
        option_d:
          'Законність, обмеження, доцільність, пропорційність, гуманність та військова необхідність',
        answer: 'option_a',
        id: 1,
      },
      {
        prompt: 'Хто такі комбатанти?',
        option_a:
          'Комбатанти – особи, які належать до однієї із сторін збройного конфлікту',
        option_b:
          'Комбатанти – особи, які можуть брати безпосередню участь у воєнних діях та входять до складу збройних сил сторін',
        option_c:
          'Комбатанти – особи, які належать до однієї із сторін збройного конфлікту однак при цьому не беруть участь у бойових діях',
        option_d:
          'Комбатанти – особи, які можуть брати безпосередню участь у воєнних діях однак при цьому не  входять до складу збройних сил сторін',
        answer: 'option_b',
        id: 2,
      },
      {
        prompt: 'Хто такі некомбатанти?',
        option_a:
          'Некомбатанти – особи, які не належать до жодної із сторін збройного конфлікту. До них належать медичний і духовний персонал, інтенданти, військові кореспонденти, юристи тощо. До вказаних осіб не має застосовуватися зброя, якщо вони зайняті виконанням своїх безпосередніх обов’язків',
        option_b:
          'Некомбатанти – особи, які не входять до складу збройних сил, однак при цьому надають їм допомогу. До них належать медичний і духовний персонал, інтенданти, військові кореспонденти, юристи тощо. До вказаних осіб не має застосовуватися зброя, якщо вони зайняті виконанням своїх безпосередніх обов’язків',
        option_c:
          'Некомбатанти – особи, які входять до складу збройних сил та надають їм допомогу, але безпосередньої участі у воєнних діях не беруть. До них належать медичний і духовний персонал, інтенданти, військові кореспонденти, юристи тощо. До вказаних осіб не має застосовуватися зброя, якщо вони зайняті виконанням своїх безпосередніх обов’язків',
        option_d:
          'Некомбатанти – особи, які не беруть безпосередню участь у бойових діях, однак при цьому виконують допоміжні функції. До них належать медичний і духовний персонал, інтенданти, військові кореспонденти, юристи тощо. До вказаних осіб не має застосовуватися зброя, якщо вони зайняті виконанням своїх безпосередніх обов’язків',
        answer: 'option_c',
        id: 3,
      },
      {
        prompt: 'Хто входить до складу збройних сил?',
        option_a:
          'Комбатанти (ті, які воюють) та некомбатанти (ті, які не воюють) - медичний і духовний персонал, інтенданти, військові кореспонденти, юристи тощо',
        option_b: 'Комбатанти (ті, які воюють)',
        option_c:
          'Некомбатанти (ті, які не воюють) - медичний і духовний персонал, інтенданти, військові кореспонденти, юристи тощо',
        option_d:
          'Особовий склад усіх військових формувань, який бере участь в бойових діях',
        answer: 'option_a',
        id: 4,
      },
      {
        prompt:
          'В яких військових кампаніях збройні сили рф порушували норми МГП? ',
        option_a: 'Російсько-грузинський збройний конфлікт 2008 року;',
        option_b:
          'Збройний конфлікт у Чеченській Республіці (1994 -1996, 1999-2000 рр.);',
        option_c: 'Усі варіанти відповідей правильні',
        option_d:
          'Участь збройних сил росії в бойових діях на території Сирійської Арабської Республіки (2015-2020 рр).',
        answer: 'option_c',
        id: 5,
      },
      {
        prompt: 'Що відноситься до військових об’єктів?',
        option_a:
          'Підрозділи збройних сил і організованих збройних формувань (особовий склад, озброєння і військова техніка), за винятком медичних формувань, санітарно-транспортних засобів, духовного персоналу та їхнього майна',
        option_b:
          'Об’єкти (споруди, будинки, позиції, казарми, склади тощо), що використовуються або підготовлені до використання у військових цілях',
        option_c:
          'Інші об’єкти, які за своїм характером, значенням, розташуванням, призначенням або використанням можуть бути використані у воєнних діях і чиє повне або часткове зруйнування, захоплення чи нейтралізація в конкретних умовах обстановки надає явну військову перевагу',
        option_d: 'Усі варіанти відповідей правильні',
        answer: 'option_d',
        id: 6,
      },
      {
        prompt: 'Які об’єкти находяться під захистом МГП?',
        option_a:
          'Медичні формування, санітарно-транспортні засоби, культурні цінності, атомні електростанції, об’єкти цивільної оборони, санітарні зони (місцевості), місцевості, що не обороняються, демілітаризовані зони',
        option_b:
          'Медичні формування, санітарно-транспортні засоби, цивільні об’єкти, культурні цінності, особливо небезпечні об’єкти, об’єкти цивільної оборони, санітарні зони (місцевості), місцевості, що не обороняються, демілітаризовані зони',
        option_c:
          'Медичні формування, санітарно-транспортні засоби, релігійні споруди, атомні електростанції, об’єкти цивільної оборони, санітарні зони (місцевості), місцевості, що не обороняються, демілітаризовані зони',
        option_d:
          'Військово-медичні формування, санітарно-транспортні засоби, релігійні та культурологічні споруди, атомні електростанції, об’єкти цивільної оборони, санітарні зони (місцевості), місцевості, що не обороняються,  демілітаризовані зони',
        answer: 'option_b',
        id: 7,
      },
      {
        prompt: 'Чи вважаються військові об’єкти законними цілями нападу?',
        option_a: 'Не вважаються',
        option_b: 'Вважаються, за умови якщо з нього виведені цивільні особи',
        option_c:
          'Військовий об’єкт залишається таким навіть у випадку, якщо на ньому перебувають цивільні особи',
        option_d: 'Немає правильної відповіді',
        answer: 'option_c',
        id: 8,
      },
      {
        prompt: 'У чому полягає принцип військової необхідності?',
        option_a:
          'Вид і ступінь сили, що застосовується, мають бути дійсно необхідними для досягнення законної військової мети та застосування такої сили не забороняється нормами МГП',
        option_b: 'Немає правильної відповіді',
        option_c:
          'Вид і ступінь сили, що застосовується, мають бути дійсно необхідними для досягнення законної військової мети',
        option_d: 'Застосування сили не заборонене нормами МГП',
        answer: 'option_a',
        id: 9,
      },
      {
        prompt: 'Які основні нормативно-правові акти МГП? ',
        option_a: 'Усі варіанти відповідей правильні',
        option_b: 'Женевські Конвенції 1949 року',
        option_c: 'Гаазька Конвенція 1908 року',
        option_d: 'Додаткові протоколи 1977',
        answer: 'option_a',
        id: 10,
      },
    ],
  },
  {
    section: 'Правила поводження із особами, які знаходяться під захистом',
    questions: [
      {
        prompt: 'Які основні джерела МГП визначають захист осіб?',
        option_a: 'Женевська конвенція І 1949 року',
        option_b: 'Женевська конвенція ІІІ 1949 року',
        option_c: 'Женевська конвенція ІV 1949 року',
        option_d: 'Усі варіанти відповідей правильні',
        answer: 'option_d',
        id: 11,
      },
      {
        prompt:
          'Хто з перелічених нижче категорій осіб знаходиться під захистом МГП?',
        option_a: 'Жертви збройних конфліктів',
        option_b:
          'Медичний і духовний персонал; парламентери і особи, які їх супроводжують',
        option_c: 'Усі варіанти відповідей правильні',
        option_d:
          'Персонал цивільної оборони; персонал, який відповідає за захист і охорону  культурних  цінностей; персонал, який бере участь у гуманітарних акціях',
        answer: 'option_c',
        id: 12,
      },
      {
        prompt:
          'Що забороняється по відношенню до осіб, які знаходяться під захистом МГП?',
        option_a: 'Таких осіб забороняється брати в полон',
        option_b: 'Таких осіб забороняється піддавати інтернуванню',
        option_c: 'Напад на таких осіб забороняється',
        option_d: 'Жодна з відповідей не правильна',
        answer: 'option_c',
        id: 13,
      },
      {
        prompt:
          'Хто відноситься до жертв збройного конфлікту відповідно до МГП?',
        option_a: 'Всі особи, які перебувають в районі воєнних дій',
        option_b:
          'Цивільні особи, які знаходяться в районі воєнних дій та на окупованій території',
        option_c:
          'Військовополонені або інші особи, свобода яких обмежена у зв’язку зі збройним конфліктом; цивільні особи, які знаходяться в районі воєнних дій та на окупованій території',
        option_d:
          'Поранені та хворі; особи, які потерпіли  корабельну аварію (аварію літального апарата); загиблі (померлі), військовополонені або інші особи, свобода яких обмежена у зв’язку зі збройним конфліктом; цивільні особи, які знаходяться в районі воєнних дій та на окупованій території',
        answer: 'option_d',
        id: 14,
      },
      {
        prompt:
          'Хто з перерахованої категорії осіб не відноситься до жертв збройного конфлікту?',
        option_a: 'Особи, родичі яких перебувають в районі бойових дій',
        option_b:
          'Загиблі; поранені; зникли безвісті; люди, які втратили житло та інше майно',
        option_c: 'Ув’язнені; незаконно позбавлені волі',
        option_d: 'Жертви переслідувань, жертви тортур, жертви посягань',
        answer: 'option_a',
        id: 15,
      },
      {
        prompt:
          'На які категорії згідно з МГП поділяються особи, свобода яких обмежена?',
        option_a:
          'Поділяються на декілька категорій, зокрема на військовополонених та цивільних інтернованих осіб',
        option_b:
          'Поділяються на декілька категорій, зокрема на військовополонених, цивільних інтернованих осіб та осіб, свобода яких обмежена у зв’язку із збройним конфліктом неміжнародного характеру',
        option_c:
          'Поділяються на декілька категорій, зокрема на цивільних інтернованих осіб та осіб, свобода яких обмежена у зв’язку із збройним конфліктом неміжнародного характеру',
        option_d:
          'Поділяються на декілька категорій, зокрема на військовополонених та осіб, свобода яких обмежена у зв’язку із збройним конфліктом неміжнародного характеру',
        answer: 'option_b',
        id: 16,
      },
      {
        prompt: 'Які дії не можна вчиняти до військовополонених?',
        option_a: 'Забирати предмети особистого користування',
        option_b:
          'Будь-які фізичні чи моральні тортури та будь-яку іншу форму примусу для одержання від них будь-яких відомостей',
        option_c: 'Усі варіанти відповідей правильні',
        option_d:
          'Піддавати фізичному каліченню або медичним чи науковим експериментам будь-якого характеру, які не обґрунтовані потребою в проведені медичного, стоматологічного або стаціонарного лікування військовополоненого та не здійснюється в його інтересах',
        answer: 'option_c',
        id: 17,
      },
      {
        prompt:
          'Що повинен мати персонал медичний, духовний, цивільної оборони та персонал, призначений для охорони культурних цінностей?',
        option_a: 'Повинен мати відповідні нарукавні знаки розрізнення',
        option_b:
          'Повинен бути включений у списки організації, що її представляє',
        option_c: 'Повинен мати посвідчення особи, що підтверджує їхній статус',
        option_d: 'Усі варіанти відповідей правильні',
        answer: 'option_c',
        id: 18,
      },
      {
        prompt:
          'Які особи відноситься до духовного персоналу (як військового, так і цивільного)?',
        option_a:
          'Які зайняті виключно виконанням своїх духовних функцій у збройних силах сторони, що перебуває в конфлікті',
        option_b:
          'Які зайняті виключно виконанням своїх духовних функцій у медичних формуваннях або санітарно-транспортних засобах сторони, що перебуває в конфлікті',
        option_c:
          'Які зайняті виключно виконанням своїх духовних функцій в організаціях цивільної оборони сторони, що перебуває в конфлікті',
        option_d: 'Усі варіанти відповідей правильні',
        answer: 'option_d',
        id: 19,
      },
      {
        prompt:
          'Хто визначає належність об’єктів до культурної спадщини, яким надається спеціальний захист?',
        option_a:
          'В Україні облік об’єктів культурної спадщини ведеться у Державному реєстрі національного культурного надбання, затвердженому постановою Кабінету Міністрів України від 12 серпня 1992 року № 466 “Про затвердження Положення про Державний реєстр національного культурного надбання”',
        option_b:
          'Старший військовий начальник, в зоні відповідальності якого ведуться воєнні дії',
        option_c:
          'Тільки за умови включення до списку об’єктів Всесвітньої спадщини ЮНЕСКО в Україні',
        option_d: 'Усі варіанти відповідей правильні',
        answer: 'option_a',
        id: 20,
      },
    ],
  },
  {
    section: 'Засоби та методи ведення бойових дій',
    questions: [
      {
        prompt: 'Що є військовими хитрощами?',
        option_a: 'Симулювання наміру вести переговори під прапором перемир’я',
        option_b:
          'Маскування, демонстративні дії, дезінформація, імітація тощо',
        option_c:
          'Симулювання володіння статусом, який надає захист, шляхом використання розпізнавальних емблем (знаків) чи форми одягу Організації Об’єднаних Націй або нейтральних держав та держав, які не беруть участі в міжнародному збройному конфлікті',
        option_d: 'Усі варіанти відповідей правильні',
        answer: 'option_b',
        id: 21,
      },
      {
        prompt:
          'З якою метою встановлюються заборони та обмеження у виборі методів і засобів ведення воєнних дій?',
        option_a:
          'З метою запобігання зайвим стражданням та невиправданим жертвам серед цивільного населення, заподіянню великого і довгострокового збитку природному середовищу, пов’язаним із воєнними діями, для сторін, що воюють',
        option_b:
          'З метою уникнення жертв серед цивільного населення, заподіянню шкоди інфраструктурі, яка не пов’язана із бойовими діями',
        option_c:
          'З метою запобігання руйнації цивільної інфраструктури, яка знаходиться під захистом міжнародного гуманітарного права',
        option_d:
          'З метою забезпечення захисту жертв конфлікту, заподіянню великого і довгострокового збитку природному середовищу, пов’язаним із воєнними діями, для сторін, що воюють',
        answer: 'option_a',
        id: 22,
      },
      {
        prompt:
          'Чи дозволяється насильно примушувати громадян держави-противника до участі у воєнних діях проти своєї держави?',
        option_a:
          'Дозволяється, у разі якщо це диктується загальновійськовою обстановкою',
        option_b: 'Дозволяється, якщо є згода на це близьких родичів',
        option_c:
          'Заборонено насильно примушувати громадян держави-противника до участі у воєнних діях проти своєї держави',
        option_d:
          'Дозволяється, якщо особа за етнічним походженням не відноситься до титульної нації держави-противника',
        answer: 'option_c',
        id: 23,
      },
      {
        prompt: 'Чи може бути взятий у полон парламентер?',
        option_a:
          'Може, якщо парламентер зухвало порушив загальні правили військової етики',
        option_b:
          'Може, якщо перемовини між сторонами збройного конфлікту виявилися безрезультатними',
        option_c:
          'Парламентер не може бути взятий у полон, однак може бути затриманий за рішенням старшого військового начальника',
        option_d:
          'Парламентер не може бути взятий у полон, йому має надаватись можливість повернутись до своїх військ (сил)',
        answer: 'option_d',
        id: 24,
      },
      {
        prompt: 'Що відноситься до заборонених методів і засобів бойових дій?',
        option_a: 'Убивати або завдавати поранення цивільним особам',
        option_b:
          'Застосовувати силу, що допускається стосовно осіб, які не мають права на захист від прямих нападів, але у конкретних обставинах перевищує необхідну для досягнення законної військової мети',
        option_c: 'Усі варіанти відповідей правильні',
        option_d:
          'Віддавати наказ “нікого не залишати в живих” або загрожувати ним',
        answer: 'option_c',
        id: 25,
      },
      {
        prompt: 'Які засоби забороняється застосувати у ході воєнних дій?',
        option_a:
          'Розривні кулі та кулі, що легко розвертаються або сплющуються в тілі людини (кулі з твердою оболонкою, яка не повністю покриває осердя або має надрізи)',
        option_b: 'Усі варіанти відповідей правильні',
        option_c:
          'Будь-які міни, що самодеактивуються, оснащені елементом невилучення, який може функціонувати після того, як міна втратила спроможність до спрацювання',
        option_d:
          'Міни, призначені для вибуху від присутності, близькості або безпосереднього впливу людини, які виводять з ладу, калічать або вбивають одного або кількох людей',
        answer: 'option_b',
        id: 26,
      },
      {
        prompt: 'Чи може військовий медичний персонал мати зброю',
        option_a:
          'Військовий медичний персонал може мати легку особисту зброю для самооборони та захисту поранених і хворих',
        option_b:
          'Відповідно до норм МГП військовий медичний персонал не може мати зброю',
        option_c:
          'Військовий медичний персонал отримує зброю за окремим рішенням старшого військового начальника',
        option_d: 'Може, якщо це вимагає загальновійськова обстановка',
        answer: 'option_a',
        id: 27,
      },
      {
        prompt:
          'За яких умов особовий склад ополчень і добровільних загонів вважається “комбатантом”? ',
        option_a:
          'Знаходяться під командуванням особи, відповідальної за своїх підлеглих',
        option_b: 'Усі варіанти відповідей правильні',
        option_c:
          'Має закріплену відмітну емблему, яка може бути розпізнана на відстані та відкрито носить зброю',
        option_d: 'Веде бойові дії відповідно до законів і звичаїв війни',
        answer: 'option_b',
        id: 28,
      },
      {
        prompt:
          'Що не відноситься до заборонених методів і засобів бойових дій? ',
        option_a: 'Вводити противника в оману шляхом віроломства',
        option_b:
          'Використовувати не за призначенням розпізнавальні емблеми Червоного Хреста, Червоного Півмісяця чи Червоного Кристала, міжнародні розпізнавальні знаки цивільної оборони та розпізнавальні знаки культурних цінностей, міжнародний спеціальний знак особливо небезпечних об’єктів, білий прапор парламентера, інші міжнародно визнані знаки і сигнали',
        option_c: 'Використання військових хитрощів',
        option_d:
          'Примушувати осіб, які знаходяться під захистом МГП, брати участь у воєнних діях',
        answer: 'option_c',
        id: 29,
      },
      {
        prompt: 'Що відноситься до заборонених методів і засобів бойових дій?',
        option_a: 'Поводитися з партизанами як з комбатантами',
        option_b:
          'Брати у полон жителів території, що не була окупована, які при наближенні ворога добровільно взялися за зброю для того, щоб чинити опір військам, що вторглися, але не мали часу самоорганізуватися (якщо вони відкрито носять зброю і дотримуються законів і звичаїв війни)',
        option_c:
          'Здійснювати вогневе ураження противника, який знаходиться в оточенні',
        option_d:
          'Знищувати, вивозити або приводити в несправність об’єкти, необхідні для виживання цивільного населення',
        answer: 'option_d',
        id: 30,
      },
    ],
  },
  {
    section: 'Відповідальність за порушення норм МГП',
    questions: [
      {
        prompt:
          'До якої відповідальності можуть бути притягнуті військовослужбовці за порушення норм МГП?',
        option_a: 'Відповідальність за порушення норм МГП несе лише держава',
        option_b:
          'Можуть бути притягнуті як до дисциплінарної, так і до кримінальної відповідальності',
        option_c:
          'Можуть бути притягнуті тільки до дисциплінарної відповідальності',
        option_d:
          'Можуть бути притягнуті тільки до кримінальної відповідальності',
        answer: 'option_b',
        id: 31,
      },
      {
        prompt:
          'Що відноситься до серйозних порушень МГП, які є воєнними злочинами?',
        option_a: 'Серйозні порушення, направлені проти людей',
        option_b: 'Серйозні порушення, направлені проти майна',
        option_c: 'Усі варіанти відповідей правильні',
        option_d:
          'Серйозні порушення, вчинені шляхом віроломного використання міжнародно-визнаних розпізнавальних емблем (знаків) і сигналів',
        answer: 'option_c',
        id: 32,
      },
      {
        prompt: 'Що не відноситься до серозних порушень МГП проти людей?',
        option_a:
          'Ненавмисне заподіяння тяжких страждань або серйозного каліцтва чи нанесення шкоди здоров’ю людини',
        option_b:
          'Здійснення нападу невибіркового характеру, коли відомо, що це стане причиною людських втрат серед цивільного населення і спричинить збиток цивільним об’єктам',
        option_c:
          'Напад на місцевості, що не обороняються, та демілітаризовані зони',
        option_d:
          'Неправомірний напад на культурні цінності, які чітко розпізнаються',
        answer: 'option_a',
        id: 33,
      },
      {
        prompt:
          'Чи звільняється начальник від відповідальності за порушення норм МГП, вчинені підлеглим?',
        option_a:
          'Звільняється від кримінальної відповідальності і може бути притягнутий лише до дисциплінарної відповідальності',
        option_b:
          'Звільняється, бо кожен військовослужбовець, у даному випадку підлеглий, сам несе індивідуальну відповідальність за порушення норм МГП',
        option_c:
          'Не звільняє, і без будь-яких застережень має бути притягнутий до дисциплінарної чи кримінальної відповідальності за порушення норм МГП підлеглою особою',
        option_d:
          'Не звільняє її начальників від дисциплінарної чи кримінальної відповідальності, якщо вони мали в своєму розпорядженні інформацію щодо намірів підлеглого і не вжили всіх можливих запобіжних заходів щодо відвернення порушень, а також якщо, маючи інформацію про вже скоєний злочин, не вжили заходів щодо притягнення до відповідальності винних',
        answer: 'option_d',
        id: 34,
      },
      {
        prompt:
          'Хто несе відповідальність за розшук осіб, які вчинили або наказали вчинити воєнні злочини (зокрема ті злочини, що стали результатом невживання необхідних запобіжних заходів)?',
        option_a: 'Держава',
        option_b: 'Національні правоохоронні органи',
        option_c: 'Міністр оборони України',
        option_d: 'Усі варіанти відповідей правильні',
        answer: 'option_a',
        id: 35,
      },
      {
        prompt:
          'Чи повинен бути виданий на вимогу іншої держави той, хто звинувачується?',
        option_a:
          'Не повинен, у зв’язку з тим, що відповідальність за серйозні порушення, скоєнні в районах бойових дій несе лише держава;',
        option_b:
          'Повинен бути виданий на вимогу іншої держави, якщо його не було притягнуто до суду за серйозні порушення МГП в його державі, із суворим дотриманням принципу, згідно з яким забороняється висилати, повертати чи видавати будь-яку особу іншій державі, якщо є серйозні підстави вважати, що їй там можуть загрожувати застосування катувань, переслідування чи інші серйозні порушення прав людини (принцип non-refoulement);',
        option_c:
          'Ні за яких обставин громадянин України не може бути виданий для судочинства на вимогу іншої держави',
        option_d:
          'Повинен бути виданий на вимогу іншої держави без будь-яких застережень',
        answer: 'option_b',
        id: 36,
      },
      {
        prompt:
          'Якими нормами повинні керуватися командири (начальники) під час збройного конфлікту?',
        option_a:
          'Подавати особистий приклад у дотриманні норм права збройних конфліктів і вимагати цього від підлеглих',
        option_b:
          'Припиняти порушення норм МГП особовим складом і за потреби притягати до відповідальності осіб, які вчинили ці порушення',
        option_c: 'Усі варіанти відповідей правильні',
        option_d:
          'Проявляти повагу та заступництво національним товариствам Червоного Хреста та Червоного Півмісяця, іншим гуманітарним товариствам, визнаним і уповноваженим урядом, за умови підпорядкування особового складу цих товариств законам воєнного часу та наказам і розпорядженням військового командування',
        answer: 'option_c',
        id: 37,
      },
      {
        prompt:
          'Яку відповідальність за порушення норм МГП несуть військовослужбовці, якщо вони не притягаються до кримінальної відповідальності?',
        option_a:
          'Військовослужбовці несуть відповідальність відповідно до нормативно-правових актів України, що передбачає матеріальну відповідальність',
        option_b:
          'Військовослужбовці несуть дисциплінарну відповідальність відповідно до вимог статутів Збройних Сил України',
        option_c: 'Відповідальність за порушення норм МГП несе лише держава',
        option_d:
          'Військовослужбовці несуть дисциплінарну відповідальність відповідно до вимог статутів Збройних Сил України та нормативно-правових актів України, що передбачають матеріальну відповідальність',
        answer: 'option_d',
        id: 38,
      },
      {
        prompt:
          'Яких заходів повинні вживати сторони збройного конфлікту у випадку серйозних порушень норм МГП?',
        option_a:
          'У випадку серйозних порушень норм МГП сторони, які знаходяться у збройному конфлікті, повинні вживати заходів як спільно, так і в індивідуальному порядку, у співробітництві з Організацією Об’єднаних Націй та відповідно до Статуту Організації Об’єднаних Націй',
        option_b:
          'У випадку серйозних порушень норм МГП сторони, які знаходяться у збройному конфлікті, повинні вживати заходів відповідно до нормативних актів національного законодавства',
        option_c:
          'У випадку серйозних порушень норм МГП сторони, які знаходяться у збройному конфлікті, повинні вживати спільних заходів у співробітництві з Організацією Об’єднаних Націй та відповідно до Статуту Організації Об’єднаних Націй',
        option_d:
          'У випадку серйозних порушень норм МГП сторони, які знаходяться у збройному конфлікті, повинні вживати індивідуальних заходів у співробітництві з Організацією Об’єднаних Націй та відповідно до Статуту Організації Об’єднаних Націй',
        answer: 'option_a',
        id: 39,
      },
      {
        prompt:
          'Які з перерахованих серозних порушень, направлені  проти майна та кваліфікуються, як не виправдані військовою необхідністю діями? ',
        option_a: 'Знищення або розграбування власності противника',
        option_b: 'Усі варіанти відповідей правильні',
        option_c: 'Присвоєння майна у великих розмірах',
        option_d: 'Великомасштабне руйнування майна',
        answer: 'option_b',
        id: 40,
      },
    ],
  },
  {
    section: 'Розслідування порушень норм МГП та докази з полю бою',
    questions: [
      {
        prompt: 'Які органи державної влади розслідують порушення норм МГП?',
        option_a: 'Служба безпеки України',
        option_b: 'Усі відповіді правильні',
        option_c: 'Національна поліція України',
        option_d: 'Офіс Генерального прокурора України',
        answer: 'option_b',
        id: 41,
      },
      {
        prompt:
          'Хто відповідає за  розслідування порушень норм МГП в Збройних Силах України?',
        option_a: 'Структури морально-психологічного забезпечення',
        option_b:
          'Командир військової частини та Військова служба правопорядку',
        option_c: 'Усі відповіді правильні',
        option_d: 'Помічник командира з правових питань',
        answer: 'option_b',
        id: 42,
      },
      {
        prompt:
          'Кому необхідно доповісти першочергово у разі, якщо Ви стали свідком або постраждалим порушення норм МГП?',
        option_a: 'Військовій службі правопорядку',
        option_b: 'Безпосередньому командиру',
        option_c: 'Національній поліції України',
        option_d: 'Помічнику командира з правової роботи',
        answer: 'option_b',
        id: 43,
      },
      {
        prompt:
          'Що із названих предметів може бути потенційними доказами у межах кримінальних проваджень?',
        option_a: 'Документи підрозділів зс рф',
        option_b: 'Усі відповіді правильні',
        option_c: 'Особисті телефони та інша техніка військовослужбовців зс рф',
        option_d: 'Військова техніка та озброєння зс рф',
        answer: 'option_b',
        id: 44,
      },
      {
        prompt:
          'Що не рекомендується робити під час звільнення тимчасово окупованих територій?',
        option_a: 'Знищувати бойові документи',
        option_b: 'Усі варіанти відповідей правильні',
        option_c: 'Забирати залишені особисті речі військовослужбовців зс рф',
        option_d:
          'Розташовувати позиції у місцях вчинення ймовірних злочинів противником',
        answer: 'option_b',
        id: 45,
      },
      {
        prompt:
          'До чого відноситься здобування достовірних даних про порушення норм МГП під час ведення бойових дій військами противника та своїми військами?',
        option_a: 'Допоміжного завдання розвідки',
        option_b: 'Основного завдання розвідки',
        option_c: 'Основного завдання юриста',
        option_d: 'Основного завдання командира батальйону',
        answer: 'option_b',
        id: 46,
      },
      {
        prompt:
          'Предмети матеріального світу, що можуть містити інформацію про воєнні злочини, і які, у випадку їх захоплення, підлягають передачі по команді?',
        option_a: 'Електронні засоби',
        option_b: 'Усі варіанти відповідей правильні',
        option_c: 'Відео- чи звукові записи',
        option_d: 'Матеріальні цінності (речі)',
        answer: 'option_b',
        id: 47,
      },
      {
        prompt:
          'У попередньому розвідувальному донесенні за результатами захоплення документів, що можуть бути використані в подальшому як докази здійснення воєнних злочинів, обов’язково зазначається?',
        option_a: 'Дата та час захоплення документів',
        option_b: 'Усі варіанти відповідей правильні',
        option_c: 'Місце захоплення документів',
        option_d: 'Підрозділ противника, якому належали захоплені документи',
        answer: 'option_b',
        id: 48,
      },
      {
        prompt:
          'Звіт про захоплення документів, матеріальних цінностей, що можуть містити інформацію про можливе вчинення воєнних злочинів складається?',
        option_a:
          'Особою (військовослужбовцем), яка у складі підрозділу (групи) здійснювала захоплення, або особою (військовослужбовцем), яка має юридичну освіту, в місці дислокації штабу військової частини',
        option_b:
          'Особисто командиром підрозділу (старшим групи), який безпосередньо здійснював захоплення відразу після прибуття підрозділу (групи) захоплення до найближчої безпечної зони',
        option_c:
          'Виключно командиром батальйону (або іншим старшим начальником) після отримання особистої доповіді командира підрозділу (старшого групи), який безпосередньо здійснював захоплення',
        option_d: 'Усі варіанти відповідей правильні',
        answer: 'option_b',
        id: 49,
      },
      {
        prompt:
          'До якої категорії відноситься захоплені документи, які можуть бути використані як докази воєнних злочинів? ',
        option_a:
          'Категорія А – захоплені документи, які мають найвищий інтерес розвідувального або іншого характеру, а також потребують негайної передачі та спеціального вивчення (обробки)',
        option_b:
          'Категорія Б – захоплені документи, які мають технічний і тактичний інтерес та розвідувальну цінність для командування військових частин і підрозділів військ',
        option_c:
          'Категорія В – особисті документи та предмети, що не містять інформації розвідувального характеру і не представляють іншого інтересу, однак вимагають особливої адміністративної відповідальності (наприклад: валюта, цінні папери, акції, сімейні фотографії або листи)',
        option_d: 'Усі варіанти відповідей правильні',
        answer: 'option_a',
        id: 50,
      },
    ],
  },
  {
    section: 'Медіа грамотність та МГП',
    questions: [
      {
        prompt: 'Хто відповідальний за комунікацію зі ЗМІ на бригадному рівні?',
        option_a:
          'Заступник командира бригади з морально-психологічного забезпечення (МПЗ)',
        option_b: 'Начальник штабу бригади',
        option_c:
          'Начальник служби зв’язків з громадськістю/пресофіцер або визначена командиром бригади особа',
        option_d: 'Усі варіанти відповідей правильні',
        answer: 'option_c',
        id: 51,
      },
      {
        prompt:
          'Хто займається акредитацією журналістів в Україні під час воєнного стану?',
        option_a: 'Пресслужба Офісу Президента України',
        option_b: 'Управління зв’язків з громадськістю ЗС України',
        option_c: 'Управління преси та інформації Міністерства оборони України',
        option_d: 'Пресцентр Служби Безпеки України',
        answer: 'option_c',
        id: 52,
      },
      {
        prompt:
          'Чи може журналіст брати зброю в руки без втрати статусу некомбатанта?',
        option_a: 'Так, для самозахисту',
        option_b: 'Можливо, за умови, якщо існує загроза для цивільних осіб',
        option_c:
          'Ні, будь-яке застосування/володіння зброї автоматично робить людину комбатантом',
        option_d: 'Так, якщо журналіст представляє релігійне ЗМІ',
        answer: 'option_c',
        id: 53,
      },
      {
        prompt: 'Які з перерахованих джерел інформації є офіційними?',
        option_a:
          'Офіційне інтернет-представництво Президента України, Веб-сторінка Збройних Сил України, ”Українська правда”, “Цензор.Нет”, телеграм-канал “Оперативний ЗСУ”, Інформаційна агенція “АрміяInform”',
        option_b:
          'Офіційне інтернет-представництво Президента України, Веб-сторінка Міністерства оборони України, фейсбук-сторінка Генерального Штабу ЗС України, Військовий портал option_defense Express, сторінка Адміністрації морських портів України, твіттер-аккаунт Помічника Президента України',
        option_c:
          'Офіційне інтернет-представництво Президента України, Веб-сторінка Міністерства оборони України, фейсбук-сторінка Генерального штабу ЗС України, Військовий портал option_defense Express, сторінка Адміністрації морських портів України, твіттер-аккаунт Помічника Президента України',
        option_d:
          'Веб-сторінка Міністерства оборони України, Веб-сторінка Збройних Сил України, фейсбук-сторінка Генерального Штабу ЗС України, Інформаційна агенція “АрміяInform”, Військовий портал option_defense Express, телеграм-канал “Оперативний ЗСУ”',
        answer: 'option_c',
        id: 54,
      },
      {
        prompt:
          'Чи є затримання журналіста в разі несанкціонованої зйомки порушенням Бернської Конвенції “Про захист прав журналістів та масмедіа 1989 року?',
        option_a: 'Так, такі дії прямо порушують Конвенцію',
        option_b:
          'Ні, бо зйомка несанкціонована, про що йдеться в статті 15, пункт 2 Конвенції',
        option_c: 'Ні, бо такої Конвенції не існує',
        option_d:
          'Так, але за умови, якщо у журналіста є акредитація Управління зв’язків з громадськістю Збройних Сил України',
        answer: 'option_c',
        id: 55,
      },
      {
        prompt:
          'З метою власної безпеки якими написами ідентифікують себе журналісти?',
        option_a: 'JOURoption_aNLIST / Roption_aoption_dIO',
        option_b: 'MEoption_dIoption_a / TELEVISION',
        option_c: 'СІVILIoption_aN ZMI/option_cORRESPONoption_dENT',
        option_d: 'PRESS / TV',
        answer: 'option_d',
        id: 56,
      },
      {
        prompt:
          'Чи захищає від полону журналіста громадянство третьої країни (США, Велика Британія, КНР тощо)?',
        option_a: 'Так, якщо це громадянство країни-члена ЄС',
        option_b: 'Ні, якщо громадянство союзників агресора',
        option_c: 'Так, якщо це громадянство США або Канади',
        option_d:
          'Ні, громадянство будь-якої не захищає журналіста від полону в районі бойових дій',
        answer: 'option_d',
        id: 57,
      },
      {
        prompt: 'Як найкраще перевірити новину на фейковість?',
        option_a: 'Спитати у знайомого військовослужбовця',
        option_b: 'Якщо є скрінщот, то можна не перевіряти',
        option_c: 'Спитати в групі “Люденьки, порадьте”',
        option_d: 'Знайти і оцінити першеджерело',
        answer: 'option_d',
        id: 58,
      },
      {
        prompt:
          'Чи дозволяє акредитація фотографувати, або знімати на відео блок-пост, або інший пункт пропуску?',
        option_a:
          'Ні, без особливого дозволу та погодження з представниками Сил оборони України це заборонено',
        option_b: 'Так, акредитація дає повну свободу дій та переміщення',
        option_c: 'Так, якщо журналіст має квитанцію про оплату такої послуги',
        option_d: 'Так, якщо блок-пост не в зоні бойових дій',
        answer: 'option_a',
        id: 59,
      },
      {
        prompt:
          'На Вашу думку скільки було видано акредитацій журналістам станом на лютий 2023 року?',
        option_a: 'Близько 7 000',
        option_b: 'Близько 2.000 – іноземним, близько 4000 українським ЗМІ',
        option_c: 'Понад 14 000',
        option_d: 'Близько 12 000',
        answer: 'option_c',
        id: 60,
      },
    ],
  },
]
